import { useMutation } from "@tanstack/react-query";
import { postTradingConnection } from "services";

export const usePostTradingConnection = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return postTradingConnection(payload);
    },
    onSuccess,
    onError,
  });
};
